import styled from 'styled-components';

export const TaskWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 15px;
  gap: 0px;
  /* height: 88px; */
  border: 1px solid rgba(0, 0, 0, 0.12);
  flex: none;
  order: 0;
  flex-grow: 0;
  margin-bottom: 5px;
`;

export const ButtonCircle = styled.button`
  border-radius: 50%;
  margin-left: 5px;
  width: 22px;
  height: 22px;
  padding: 4px;
  background: rgb(146 182 217);
  border: 0px solid;
  color: #fff;
  text-align: center;
`;